import React, { useState } from "react";
import { Container, Form, Button, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../constants";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      // Basic email validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        setMessage('Please enter a valid email address.');
        return;
      }
  
      try {
        setLoading(true);
  
        await axios.post(`${BASE_URL}/users/resetPasswordRequest`, { email });
  
        // Update the message state upon successful submission
        setMessage('Check your email to update your password.');
      } catch (error) {
        console.error('Error sending email:', error.message);
        setMessage('Failed to send the email. Please try again.');
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <Container className="mt-5" style={{ maxWidth: "400px" }}>
        <h3>Forgot Password</h3>
        {message && <Alert variant="info">{message}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId='email'>
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type='email'
              placeholder='Enter email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
  
          <Button type='submit' variant='primary' className='mt-3' disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Send Email'}
          </Button>
        </Form>
      </Container>
    );
};
  
export default ForgotPassword;